import { render, staticRenderFns } from "./LabSelection.vue?vue&type=template&id=e484e3e0"
import script from "./LabSelection.vue?vue&type=script&lang=js"
export * from "./LabSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports